import * as React from 'react';
import SamsungPayHeader from '../../components/common/SamsungPayHeader';
import SamsungPayBox from '../../components/common/SamsungPayBox';
import debug from 'debug';
import {useEffect, useState} from 'react';
import CancelButton from "../../components/buttons/CancelButton";
import {useTranslation} from "react-i18next";
import styles from '../../css/pc/PcGeneral.module.css';
import classNames from 'classnames/bind';
import {useNavigate} from "react-router-dom";
import {useSelector} from "react-redux";
import CardListForStageTest from "../../components/CardListForStageTest";
import Loading from "../../components/Loading";
import {fetchDummyPaymentCredentials, fetchPayableCards} from "../../libs/GsmpiApiForStageTest";

const cx = classNames.bind(styles);

const log = debug('app:PcBridgeForStageWithoutApkPage');
export default function PcBridgeForStageWithoutApkPage() {
  const {t} = useTranslation();
  const navigate = useNavigate();
  const {transactionId, serviceId} = useSelector((state) => state.paymentClient);
  const [selectedCardId, setSelectedCardId] = useState(null);
  const [loading, setLoading] = useState(true);
  const [cards, setCards] = useState([]);

  function getPayableCards(transactionId) {
    setLoading(true);
    fetchPayableCards({transactionId: transactionId}).then((result) => {
      setCards(result.data.cards);
    }).catch(error => {
      log.error(error); // todo: show error to visible
      navigate('/gsmpi-web/error');
    }).finally(() => {
      setLoading(false);
    });
  }

  function getDummyPaymentCredentials(transactionId, cardId) {
    fetchDummyPaymentCredentials({transactionId: transactionId, cardId: cardId, serviceId: serviceId})
      .then((result) => {
        const state = {
          state: {
            paymentCredential: result.data,
          }
        };
        navigate('/gsmpi-web/done', state);
      }).catch(() => navigate('/gsmpi-web/error'));
  }

  useEffect(() => {
    getPayableCards(transactionId);
  }, []);

  const handleSelectCard = (cardId) => {
    setSelectedCardId(cardId);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!selectedCardId) {
      alert("Please select a card");
      return;
    }

    const selectedCard = cards.find((c) => c.id === selectedCardId);
    getDummyPaymentCredentials(transactionId, selectedCard.id);
  };

  return (
    <>
      <SamsungPayBox>
        <SamsungPayHeader headerMessage="This is STAGE Test Interface. Dummy Credentials will be returned." />
        {loading ?  <Loading /> :
          <div>
            <div style = {{ padding: 10}}>
              <CardListForStageTest
                cards={cards}
                onSelectedCardIdChange={handleSelectCard}
                selectedCardId={selectedCardId}
              />
            </div>

            <div className="mpi-email-boxbottom">
              <div className={`${cx('mpi-button')} ${cx('is-clearfix')}`}>
                <CancelButton className={cx('mpi-button-cancel')} transactionId={transactionId} />
                <button type="button" className={cx('mpi-button-submit')} onClick={handleSubmit}>
                  {t('pay.gsmpi.main.button2')}
                </button>
              </div>
            </div>
          </div>
        }
      </SamsungPayBox>
    </>
  );
}